/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BedType } from './BedType';
import {
    BedTypeFromJSON,
    BedTypeFromJSONTyped,
    BedTypeToJSON,
    BedTypeToJSONTyped,
} from './BedType';

/**
 * 
 * @export
 * @interface BulkUpdateBedTypes200Response
 */
export interface BulkUpdateBedTypes200Response {
    /**
     * 
     */
    data?: Array<BedType>;
}

/**
 * Check if a given object implements the BulkUpdateBedTypes200Response interface.
 */
export function instanceOfBulkUpdateBedTypes200Response(value: object): value is BulkUpdateBedTypes200Response {
    return true;
}

export function BulkUpdateBedTypes200ResponseFromJSON(json: any): BulkUpdateBedTypes200Response {
    return BulkUpdateBedTypes200ResponseFromJSONTyped(json, false);
}

export function BulkUpdateBedTypes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateBedTypes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BedTypeFromJSON)),
    };
}

export function BulkUpdateBedTypes200ResponseToJSON(json: any): BulkUpdateBedTypes200Response {
    return BulkUpdateBedTypes200ResponseToJSONTyped(json, false);
}

export function BulkUpdateBedTypes200ResponseToJSONTyped(value?: BulkUpdateBedTypes200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BedTypeToJSON)),
    };
}

